function authHeaders() {
  const token = sessionStorage.getItem("syrakis_token");
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function platformFetch(path, options = {}) {
  const response = await fetch(path, {
    credentials: "same-origin",
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) },
  });
  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json") ? await response.json() : null;
  if (!response.ok) {
    const error = new Error(payload?.message || payload?.error || `HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function loginWithPassword(payload) {
  return platformFetch("/api/auth/login", { method: "POST", body: JSON.stringify(payload) });
}

export function listIamRoles() {
  return platformFetch("/iam-api/roles");
}

export function listIamUsers() {
  return platformFetch("/iam-api/v1/users");
}

export function createIamRole(payload) {
  return platformFetch("/iam-api/roles", { method: "POST", body: JSON.stringify(payload) });
}

export function updateIamRole(id, payload) {
  return platformFetch(`/iam-api/roles/${id}`, { method: "PUT", body: JSON.stringify(payload) });
}

export function updateIamUser(id, payload) {
  return platformFetch(`/iam-api/v1/users/${id}`, { method: "PUT", body: JSON.stringify(payload) });
}

export function deleteIamRole(id) {
  return platformFetch(`/iam-api/roles/${id}`, { method: "DELETE" });
}

export function listDirectorioEmpresas({ page = 1, pageSize = 10, search = "" } = {}) {
  const params = new URLSearchParams({ page: String(page), page_size: String(pageSize), search });
  return platformFetch(`/api/core-directorio/empresas?${params.toString()}`);
}

export function getDirectorioEmpresa(id) {
  return platformFetch(`/api/core-directorio/empresas/${id}`);
}

export function createDirectorioEmpresa(payload) {
  return platformFetch("/api/core-directorio/empresas", { method: "POST", body: JSON.stringify(payload) });
}

export function updateDirectorioEmpresa(id, payload) {
  return platformFetch(`/api/core-directorio/empresas/${id}`, { method: "PUT", body: JSON.stringify(payload) });
}

export function deactivateDirectorioEmpresa(id) {
  return platformFetch(`/api/core-directorio/empresas/${id}`, { method: "DELETE" });
}

export async function importDirectorioEmpresas(rows) {
  return platformFetch("/api/core-directorio/empresas/importar", { method: "POST", body: JSON.stringify({ rows }) });
}

export function listCoreTrabajadoresContactos({ page = 1, pageSize = 10, search = "", companyId = "", tipoContacto = "", withoutCargo = false } = {}) {
  const params = new URLSearchParams({ page: String(page), page_size: String(pageSize), search });
  if (companyId) params.set("empresa_id", String(companyId));
  if (tipoContacto) params.set("tipo_contacto", tipoContacto);
  if (withoutCargo) params.set("sin_cargo", "1");
  return platformFetch(`/api/core-trabajadores/contactos?${params.toString()}`);
}

export function getCoreTrabajadoresCatalogos() {
  return platformFetch("/api/core-trabajadores/catalogos");
}

export function createCoreTrabajadorContacto(payload) {
  return platformFetch("/api/core-trabajadores/contactos", { method: "POST", body: JSON.stringify(payload) });
}

export function updateCoreTrabajadorContacto(id, payload) {
  return platformFetch(`/api/core-trabajadores/contactos/${id}`, { method: "PUT", body: JSON.stringify(payload) });
}

export function deactivateCoreTrabajadorContacto(id) {
  return platformFetch(`/api/core-trabajadores/contactos/${id}`, { method: "DELETE" });
}
